//Utility function to relativize the urls from all the calls in the frontend
export function getContextPath(): string {
   //removal of the host and protocol since they are already inserted from the Request class
  //if not removed, the url becomes invalid, like: http://127.0.0.1:9191http://127.0.0.1:9191/api
  const currentLocation = removeHostAndProtocol(window.location.href);
  return currentLocation.substring(0, currentLocation.lastIndexOf('/feed'));
}

function removeHostAndProtocol(url: string): string {
  return url.replaceAll(window.location.protocol + '//' + window.location.host, '');
}
